export default "/images/login-vector1.svg?e8cf3ada93dc6a8a5c24b1a94bbbb1c9";